interface ProfileMenuProps {
  onProfileClick: () => void;
  onLogoutClick: () => void;
}

const ProfileMenu = ({ onProfileClick, onLogoutClick }: ProfileMenuProps) => {
  return (
    <div className="absolute right-0 top-5 w-40 rounded-md bg-white shadow-lg z-50">
      <div className="py-1">
        <button
          onClick={onProfileClick}
          className="block w-full px-4 py-2 text-left text-sm text-gray-701 hover:bg-gray-101"
        >
          Account Settings
        </button>
        <button
          onClick={onLogoutClick}
          className="block w-full px-4 py-2 text-left text-sm text-gray-701 hover:bg-gray-101"
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default ProfileMenu;
